import axios from "axios";
import nativeHandlerService from "../nativeHandler";
import store from "@/store";
import { presetTokens } from "@/store/modules/presetTokens.js";

// 使う一覧のみ挙動が異なるので、第4引数にフラグ
export const authWrapper = async (
  method,
  apiName,
  params,
  isNotReCall = false,
  dbsSessionId, // DBSのログイン必須APIでのみ使用
  endPoint
) => {
  try {
    console.log("apiName :>> " + apiName);
    console.log("params :>> ", params);
    return await apiCall(method, apiName, params, dbsSessionId, endPoint);
  } catch (err) {
    // 認証エラーの場合(local: internal_error, app: parameter_error, Network Errorでresponseがない)、nativeのrefreshTokenコール
    // 未ログインならnativeでダイアログ出すので、WebViewではerror throwしない
    // 使う一覧の場合は、ダイアログを出さない。リフレッシュトークン実行=未ログイン時ダイアログ表示となるので、リフレッシュトークン自体コールしない。
    if (
      !isNotReCall &&
      (!err.response ||
        err.response.data.error == "internal_error" ||
        err.response.data.error == "parameter_error")
    ) {
      // receive error when run debug
      if (process.env.NODE_ENV == "local") {
        throw err;
      }
      // nativeからのtoken返却を感知するため、storeにフラグセット
      store.commit("common/setIsApiPending", true);
      nativeHandlerService.refreshToken();

      // ネイティブからのtoken返却を監視
      return await interval(method, apiName, params, dbsSessionId, endPoint);
    } else {
      throw err;
    }
  }
};

const apiCall = async (method, apiName, params, dbsSessionId, endPoint) => {
  let headers =
    process.env.NODE_ENV === "local"
      ? {
        Authorization: "Bearer " + presetTokens.state.idToken,
        "Access-Token": presetTokens.state.accessToken,
      }
      : {
        Authorization: store.getters["common/idToken"],
        "Access-Token": store.getters["common/accessToken"],
      };

  if (dbsSessionId) {
    headers["x-bks-sessionid"] = dbsSessionId;
  }

  // defaultはBFF それ以外はURL指定
  let client;
  switch (endPoint) {
    case "Mixway":
      client = axios.create({
        baseURL: process.env.VUE_APP_MIXWAY_API_URL,
      });
      break;
    case "Notification":
      client = axios.create({
        baseURL: process.env.VUE_APP_NOTIFICATION_API_URL,
      });
      break;
    case "E-BUS":
      headers = {
        Authorization: "Bearer " + store.getters["demand/demandToken"].token
      }
      client = axios.create({
        baseURL: process.env.VUE_APP_DEMAND_AI_BUS_WRAPPER_API_URL,
        headers
      });
      break;
    case "Migrated":
      client = axios.create({
        baseURL: process.env.VUE_APP_BFF_API_URL,
        headers,
      });
      console.log("endpoint :>> ", endPoint);
      break;
    default:
      client = axios.create({
        baseURL: process.env.VUE_APP_BFF_API_URL_VAL,
        headers,
      });
  }
  switch (method) {
    case "GET":
      return await client.get(apiName, params);
    case "POST":
      return await client.post(apiName, params);
    case "PUT":
      return await client.put(apiName, params);
    case "DELETE":
      return await client.delete(apiName, params);
  }
};

const interval = async (method, apiName, params, dbsSessionId, endPoint) => {
  const _interval = async () => {
    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });
    const isApiPending = store.getters["common/isApiPending"];
    // ネイティブからtokenが返されるとisApiPending=falseになるので(NativeHandlerMixinに記述)、APIを再コールする
    if (isApiPending) {
      return await _interval();
    } else {
      return await apiCall(method, apiName, params, dbsSessionId, endPoint);
    }
  };
  return await _interval();
};
